import crypto from 'crypto'

export function encryptPassword (pass) {
  const privateKey = '4688b058-8f1a-428c-92a4-947686d58e78'
  const key = crypto.createHash('sha256').update(privateKey).digest('hex')

  let encrypted = ''
  for (let i = 0; i < pass.length; i++) {
    encrypted += String.fromCharCode(pass.charCodeAt(i) ^ key.charCodeAt(i % key.length))
  }
  return btoa(encrypted)
}
